import { Component, Input, OnInit } from '@angular/core';

/**ToDo Documentazione */
@Component({
  selector: 'app-extra',
  styleUrls: ['./extra.component.scss'],
  templateUrl: './extra.component.html'
})
export class ExtraComponent implements OnInit {
  @Input() public days: any;
  @Input() public defaultImage: any;
  public deflusedCategories: string[] = [];
  @Input() public deflusso: any;
  @Input() public extra: any;
  public groupedFees: any[] = [];
  public groupedInsurances: any[] = [];
  @Input() public imageFee: any;
  @Input() public imageInsurance: any;
  @Input() public noImageUrl: any;
  /** true quando il tab "Altri servizi" è personalizzato dal tenant (`altriServizi`). */
  @Input() public personalized = false;
  @Input() public replaceShowDescriptionButtonWithNotes = false;
  @Input() public serviceIcons: any;
  @Input() public version: any;

  public ngOnInit(): void {
    this.groupItems();
  }

  private groupItems(): void {
    this.groupedFees = this.groupByName(this.getVisibleFees());
    this.groupedInsurances = this.groupByName(this.getVisibleInsurances());
    this.deflusedCategories = this.getActivityCategories();
  }

  /**
   * Fee del tab: con personalizzazione assente o `deflusso.fee` assente rende tutte
   * le fee (default invariato); `fee:false` ⇒ nessuna; `fee:true` ⇒ solo le fee con
   * `managementCode` in `feeManagementCodes` (vuoto/assente ⇒ nessuna, doc r.540-541);
   * `fee` array ⇒ solo le fee con `managementCode` nell'array.
   */
  private getVisibleFees(): any[] {
    const fees: any[] = this.extra?.fees || [];

    if (!this.personalized) {
      return fees;
    }

    const fee = this.deflusso?.fee;

    if (fee === false) {
      return [];
    }

    if (fee === undefined || fee === null) {
      return fees;
    }

    const codes: string[] = Array.isArray(fee) ? fee : this.getFeeManagementCodes();

    return fees.filter((item: any) => codes.includes(item?.managementCode));
  }

  /** Assicurazioni del tab: escluse solo se `deflusso.insurances` è esplicitamente false. */
  private getVisibleInsurances(): any[] {
    const insurances: any[] = this.extra?.insurances || [];

    if (this.personalized && this.deflusso?.insurances === false) {
      return [];
    }

    return insurances;
  }

  /** Tipologie activity da mostrare nel tab (allowlist); vuoto ⇒ nessuna activity. */
  private getActivityCategories(): string[] {
    if (!this.personalized) {
      return [];
    }

    const categories = this.deflusso?.activityCategories;

    return Array.isArray(categories) ? categories : [];
  }

  /** Codici allowlist di `feeManagementCodes`. */
  private getFeeManagementCodes(): string[] {
    const codes = this.deflusso?.feeManagementCodes;

    return Array.isArray(codes) ? codes : [];
  }

  private groupByName(items: any[]): any[] {
    const grouped: { [key: string]: any[] } = {};

    // Raggruppa gli item per name
    items.forEach(item => {
      if (!grouped[item.name]) {
        grouped[item.name] = [];
      }
      grouped[item.name].push(item);
    });

    // Crea l'array finale con il conteggio
    const result: any[] = [];
    Object.keys(grouped).forEach(name => {
      const itemsWithSameName = grouped[name];
      const count = itemsWithSameName.length;

      // Prende il primo item come base e aggiunge il conteggio se necessario
      const baseItem = itemsWithSameName[0];

      if (count === 1) {
        // Se c'è solo un item, non aggiungere contatore
        result.push(baseItem);
      } else {
        // Se ci sono più item con lo stesso name, aggiungi il conteggio
        result.push({
          ...baseItem,
          displayName: `${baseItem.name} x${count}`
        });
      }
    });

    return result;
  }

}
